export const routesParametre = [
  {
    path: "/parametre",
    name: "parametre-list",
    component: () => import("@/views/parametre/index.vue"),
    meta: {
      public: false,
      title: "parametre.Parametre",
      yetki: { k: [1020902] },
    },
  },
]
